"use client";

import React from "react";

import { iconColor } from "../colors";
import { createSVGIcon } from "../createSVGIcon";
import { iconCls } from "../tracking";

/**
 * @figma designed by Nick Howland (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=12624%3A170))
 * @lastsynced 2026-10-29T13:51:57.062Z
 * @trackcomponent
 * @optimized using svgo:^3.3.4
 */
export const HeartSolid = createSVGIcon(
  <path
    d="M12 21.343 2.54 12.69C-2.571 7.58 4.949-2.33 12 5.66c7.05-7.99 14.572 1.92 9.461 7.03z"
    fill="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    stroke="currentColor"
  />,
  "HeartSolid",
  {
    className: iconCls(),
    color: iconColor.primary,
    fill: "none",
    viewBox: "0 0 24 24",
  } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
